import { render, staticRenderFns } from "./PaymentSuccessFaq.vue?vue&type=template&id=ae2115b4"
import script from "./PaymentSuccessFaq.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports